export const FOCUS_QUERY = ["input", "select", "textarea", "button", "object", "a[href]", "area[href]", "[tabindex]"].map(i => i + ':not([disabled]):not([tabindex="-1"])').join(", ");

export const isElementVisible = (element: HTMLElement | Element) => {
    if (typeof element.checkVisibility == "function") {
        return element.checkVisibility({ checkVisibilityCSS: true });
    } else {
        while (element != null) {
            const style = window.getComputedStyle(element);
            if (style.display === "none" || style.visibility === "hidden") {
                return false;
            }
            element = element.parentElement!;
        }
        return true;
    }
};
